var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useQueries } from "@tanstack/react-query";
import { useDashboardCatalog } from "../../../shared/dashboard/hooks/useDashboardCatalog";
import { fetchLgbtqiaChartData } from "../services/lgbtqia.service";
import { lgbtqiaQueryKeys } from "../query-keys/lgbtqia.query-keys";
var buildLoadingChart = function (chart) { return ({
    id: chart.id,
    title: chart.title,
    subtitle: chart.subtitle,
    chartType: chart.chartType,
}); };
var resolveDynamicChartConfigs = function (year, catalog) {
    var _a;
    var subtab = (_a = catalog === null || catalog === void 0 ? void 0 : catalog.domains.find(function (domain) { return domain.id === "lgbtqia"; })) === null || _a === void 0 ? void 0 : _a.sections.find(function (item) { return item.slug === year; });
    if (!subtab)
        return null;
    return subtab.charts.map(function (chart) { return ({
        id: chart.id,
        title: chart.title,
        subtitle: chart.subtitle,
        chartType: chart.chartType,
        endpoint: chart.endpoint,
    }); });
};
export function useLgbtqiaCharts(year) {
    var _this = this;
    var _a;
    var _b = useDashboardCatalog(), catalog = _b.catalog, catalogLoading = _b.loading;
    var chartConfigs = (_a = resolveDynamicChartConfigs(year, catalog)) !== null && _a !== void 0 ? _a : [];
    var chartResults = useQueries({
        queries: catalogLoading
            ? chartConfigs.map(function (chart) { return ({
                queryKey: lgbtqiaQueryKeys.chart(year, chart.id),
                enabled: false,
                queryFn: function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        throw new Error("Query desabilitada durante carregamento do catálogo.");
                    });
                }); },
            }); })
            : chartConfigs.map(function (chart) { return ({
                queryKey: lgbtqiaQueryKeys.chart(year, chart.id),
                queryFn: function () { return fetchLgbtqiaChartData(chart.endpoint); },
            }); }),
    });
    return chartConfigs.map(function (chart, index) {
        var result = chartResults[index];
        if (result === null || result === void 0 ? void 0 : result.data) {
            return __assign(__assign({}, buildLoadingChart(chart)), { data: result.data.data });
        }
        if (result === null || result === void 0 ? void 0 : result.error) {
            return __assign(__assign({}, buildLoadingChart(chart)), { error: result.error instanceof Error
                    ? result.error.message
                    : "Não foi possível obter os dados." });
        }
        return buildLoadingChart(chart);
    });
}
